import { render, staticRenderFns } from "./popup-activity.vue?vue&type=template&id=3d0644e2&scoped=true"
import script from "./popup-activity.vue?vue&type=script&lang=ts"
export * from "./popup-activity.vue?vue&type=script&lang=ts"
import style0 from "./popup-activity.vue?vue&type=style&index=0&id=3d0644e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0644e2",
  null
  
)

export default component.exports